import moment from 'moment';

export function dateUtils() {

	const addDays = (date, days) => {

		return new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
	};

	const formatStringDate = (stringDate, format)  => {
		return moment(stringDate).format(format);
	};

	const humanizedDurationFromNow = (utcStringDate, ago = false) => {
		const duration = moment.utc() - moment.utc(utcStringDate);
		return moment.duration(-duration).humanize(ago);
	};

	return {
		addDays,
		formatStringDate,
		humanizedDurationFromNow
	};
}

